"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useModalContext = exports["default"] = exports.ROOT_TRANSTION_CLASS = exports.ModalContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactTransitionGroup = require("react-transition-group");
var _isBrowser = _interopRequireDefault(require("../../utils/is-browser"));
var _sharedVariables = require("../../shared-variables");
var _modalPortal = _interopRequireDefault(require("./modal-portal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ModalContext = exports.ModalContext = /*#__PURE__*/(0, _react.createContext)({});
var useModalContext = exports.useModalContext = function useModalContext() {
  return (0, _react.useContext)(ModalContext);
};
var ROOT_TRANSTION_CLASS = exports.ROOT_TRANSTION_CLASS = 'sb-modal-transition';

/**
 * An accessible modal component manager. ModalProvider does not create any UI of its own;
 * it is intended to work with the modal UI components in this library such as Overlay.
 * ModalProvider will handle opening and closing your UI component and manages focus,
 * close on Escape, mask animation, and key accessible attributes.
 *
 * There are four main steps to leverage ModalProvider:
 *
 * The main export, ModalProvider, should be wrapped around your entire React application
 * as near to the application root as possible. ModalProvider leverages React Context
 * to expose the openModal and closeModal methods to your entire app.
 *
 * In your html, create a sibling div to your React app's root div. Set a unique id attribute
 * on that div, and pass that id as the targetElementId prop of the ModalProvider created in
 * step one. ModalProvider uses a React Portal, and this targetElementId tells the provider
 * where to render your modals. Using a sibling div to the react app makes z-index handling
 * much easier.
 *
 * In your application, wherever you need to launch a modal, import ModalContext from this
 * component, and access it using the React.useContext hook. This will give you access to
 * the openModal method; now you simply pass the component you want to render to openModal via
 * its 'component' property. See example to the right.
 *
 * Also check out our Overlay docs for an
 * <a href="/components/overlay">example using Overlays</a>.
 *
 */

// *** DO NOT CONVERT TO FUNCTIONAL COMPONENT ***
// Until addressing the shared state issue in MFA & Re-Auth components in core
// More info about the issue: https://scm.starbucks.com/starbucks-web/pattern-library/pull/1155/files#r390910
var ModalProvider = /*#__PURE__*/function (_Component) {
  function ModalProvider() {
    var _this;
    _classCallCheck(this, ModalProvider);
    _this = _callSuper(this, ModalProvider);
    _defineProperty(_this, "openModal", function (_ref) {
      var ariaLabel = _ref.ariaLabel,
        ariaLabelledBy = _ref.ariaLabelledBy,
        ModalComponent = _ref.component,
        componentProps = _ref.componentProps,
        id = _ref.id,
        modalRootProps = _ref.modalRootProps,
        _ref$onClose = _ref.onClose,
        onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
        _ref$onEscape = _ref.onEscape,
        onEscape = _ref$onEscape === void 0 ? function () {} : _ref$onEscape;
      _this.setState(function (prevState) {
        var _window;
        return {
          openModalLayers: prevState.openModalLayers.concat([{
            ariaLabel: ariaLabel,
            ariaLabelledBy: ariaLabelledBy,
            Component: ModalComponent,
            componentProps: componentProps,
            id: id,
            modalRootProps: modalRootProps,
            onClose: onClose,
            onEscape: onEscape,
            returnFocusTarget: (_window = window) === null || _window === void 0 || (_window = _window.document) === null || _window === void 0 ? void 0 : _window.activeElement
          }])
        };
      });
    });
    _defineProperty(_this, "handleClosingModal", function (modalToClose) {
      modalToClose.onClose();
      modalToClose.returnFocusTarget.focus();
    });
    _defineProperty(_this, "closeById", function (id) {
      var modalToClose = _this.state.openModalLayers.find(function (modal) {
        return modal.id === id;
      });
      if (!modalToClose) {
        return;
      }
      _this.setState({
        openModalLayers: _this.state.openModalLayers.filter(function (modal) {
          return modal.id !== id;
        })
      });
      _this.handleClosingModal(modalToClose);
    });
    _defineProperty(_this, "getMostRecentModal", function () {
      return _this.state.openModalLayers[_this.state.openModalLayers.length - 1];
    });
    _defineProperty(_this, "closeModal", function (id) {
      if (_this.state.openModalLayers.length === 0) {
        return;
      }
      if (id) {
        _this.closeById(id);
        return;
      }
      // If a specific identifier is not requested to be closed,
      // close the "highest" (most recently added one)
      var modalToClose = _this.getMostRecentModal();
      _this.setState(function (prevState) {
        return {
          openModalLayers: prevState.openModalLayers.slice(0, -1)
        };
      });
      _this.handleClosingModal(modalToClose);
    });
    _this.state = {
      openModalLayers: []
    };
    _this.openModal = _this.openModal.bind(_this);
    _this.closeModal = _this.closeModal.bind(_this);
    _this.handleClosingModal = _this.handleClosingModal.bind(_this);
    _this.closeById = _this.closeById.bind(_this);
    _this.getMostRecentModal = _this.getMostRecentModal.bind(_this);
    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
    return _this;
  }
  _inherits(ModalProvider, _Component);
  return _createClass(ModalProvider, [{
    key: "handleKeyPress",
    value: function handleKeyPress(e) {
      if ((e === null || e === void 0 ? void 0 : e.key) === 'Escape' && this.state.openModalLayers.length > 0) {
        var _this$getMostRecentMo, _this$getMostRecentMo2;
        ((_this$getMostRecentMo = this.getMostRecentModal()) === null || _this$getMostRecentMo === void 0 || (_this$getMostRecentMo2 = _this$getMostRecentMo.onEscape) === null || _this$getMostRecentMo2 === void 0 ? void 0 : _this$getMostRecentMo2.call(_this$getMostRecentMo)) || this.closeModal();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _window2;
      (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.document) === null || _window2 === void 0 || _window2.addEventListener('keydown', this.handleKeyPress);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _window3;
      (_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.document) === null || _window3 === void 0 || _window3.removeEventListener('keydown', this.handleKeyPress);
    }
  }, {
    key: "render",
    value: function render() {
      var _window4,
        _this2 = this;
      var animatorRef = /*#__PURE__*/(0, _react.createRef)();
      var _this$props = this.props,
        children = _this$props.children,
        targetElementId = _this$props.targetElementId;
      if (!_isBrowser["default"]) {
        return children;
      }
      var targetElement = (_window4 = window) === null || _window4 === void 0 || (_window4 = _window4.document) === null || _window4 === void 0 ? void 0 : _window4.getElementById(targetElementId);
      return /*#__PURE__*/_react["default"].createElement(ModalContext.Provider, {
        value: {
          openModalLayers: this.state.openModalLayers,
          hasOpenModal: Boolean(this.state.openModalLayers.length),
          openModal: this.openModal,
          closeModal: this.closeModal,
          getMostRecentModal: this.getMostRecentModal
        }
      }, children, /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.TransitionGroup, {
        appear: true,
        component: null
      }, this.state.openModalLayers.map(function (modal, idx) {
        return /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
          classNames: ROOT_TRANSTION_CLASS,
          key: modal.id || modal.ariaLabelledBy || idx,
          nodeRef: animatorRef,
          timeout: {
            enter: parseInt(_sharedVariables.variables.defaultAnimationEntranceDuration, 10),
            exit: parseInt(_sharedVariables.variables.defaultAnimationExitDuration, 10)
          }
        }, /*#__PURE__*/_react["default"].createElement(_modalPortal["default"]
        // Mark the topmost modal as aria-modal, which prevents access by screen readers
        // to other modals and the underlying main application as well
        // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-modal
        , {
          ariaModal: idx === _this2.state.openModalLayers.length - 1,
          closeModal: _this2.closeModal,
          modal: modal,
          ref: animatorRef,
          targetElement: targetElement
        }));
      })));
    }
  }]);
}(_react.Component);
ModalProvider.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The portion of the React application that will have access to the ModalProvider
   * 'openModal' and 'closeModal' methods. Generally, the ModalProvider should be near
   * the root of your React app.
   */
  children: _propTypes["default"].any,
  /**
   * String id attribute on the element to which modals will be attached.
   */
  targetElementId: _propTypes["default"].string
} : {};
var _default = exports["default"] = ModalProvider;